/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Currency } from '../../models/currency';
import { ExpenseCategory } from '../../models/expense-category';
import { Int32ApiResponse } from '../../models/int-32-api-response';

export interface CreateExpenseAsync$Params {
      body?: {
'Description'?: string;
'Amount'?: number;
'Category'?: ExpenseCategory;
'Date'?: string;
'Notes'?: string;
'Currency'?: Currency;
'File'?: Blob;
}
}

export function createExpenseAsync(http: HttpClient, rootUrl: string, params?: CreateExpenseAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<Int32ApiResponse>> {
  const rb = new RequestBuilder(rootUrl, createExpenseAsync.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Int32ApiResponse>;
    })
  );
}

createExpenseAsync.PATH = '/api/expense';
